import { Box } from "@mui/material";
import { ParagraphText, UBAppModal, UBButton } from "../../../Libraries";
import { Fragment, useContext, useState } from "react";
import { formatNum } from "../../../oscar-pos-core/constants";
import { LanguageContext } from "../../../context/LanguageContext";
import {
  dateFormatInNumberWithSpace,
  getAttachmentName,
  openFileInNewTab,
  resolveCategoryDisplayName,
} from "../../../utils";
import withObservables from "@nozbe/with-observables";
import { catchError, map, of, switchMap } from "rxjs";
import { useNavigate } from "react-router-dom";
import UBRightSidebar from ".";
import {
  BackIconNew,
  DownloadIcon,
  InfoIconNew,
} from "../../../assets/icons/icon";
import { useAuthContext } from "../../../context/AuthContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import useDownlaodPdf from "../../../hooks/useDownlaodPdf";
import QuickSalePaymentDetails from "../../container/QuickSale/QuickSalePaymentDetails";
import AppCustomerSiderbarDetail from "../AppCustomerSiderbarDetail";
import styles from "./styles.module.css";

const SidebarBodyContent = ({
  open,
  onClose,
  quickSale,
  orders,
  paymentImage,
  handleDelete,
  handleEdit,
  customerDetail,
  handleMarkAsPaid,
  customerInfoData,
  isNotShowReceipt,
  firstButtonTitle,
  otherCstmBtn,
  invoiceBtnTitle,
  isShowDeleteBtn = true,
  isShowEditBtn = true,
  isCustomerTransaction,
  isShowAttachment = true,
  unpaidAmountVariant = "quickSale",
  hideReceiptActions = false,
  isShowInvoiceDownload = true,
  invoiceFileName = "Rupin Sale Invoice",
}) => {
  const imageUrl = paymentImage
    ? paymentImage
    : quickSale?.attachment?.length
      ? quickSale?.attachment
      : quickSale?.image_url
        ? quickSale?.image_url
        : "";

  const [previewImageOpen, setPreviewImageOpen] = useState(false);
  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();
  const { onDownload, downloadLoading } = useDownlaodPdf(user);

  const handleEditIcon = () => {
    triggerLogEvent(analytics, "sidebar_edit_btn", {
      id: quickSale?.id,
      status: quickSale?.status,
    });
    navigate(`/QuickSale/QuickSaleForm/Edit/${quickSale.id}`);
  };

  const handleDownload = async () => {
    let paramsForReport = {
      template_name: "invoicereport.hbs",
      name: `${invoiceFileName}.pdf`,
      invoice_id: quickSale.id,
      template_style: localStorage.getItem("invoiceStyle") || "style1",
      template_color: localStorage.getItem("invoiceColor") || "#000000",
      pdf: true,
    };

    const pdfType = "Invoice";
    const onSuccessDownload = () => {
      triggerLogEvent(analytics, "sidebar_download", {
        id: quickSale?.id,
        status: quickSale?.status,
      });
    };
    onDownload(paramsForReport, onSuccessDownload, navigate, pdfType, business);
  };

  const CustInfoData = customerInfoData
    ? customerInfoData
    : [
        {
          title: I18n.date,
          value: dateFormatInNumberWithSpace(quickSale?.created_at),
        },
        {
          title: I18n.contact,
          value: customerDetail?.name || "-",
        },
        {
          title: I18n.category,
          value: quickSale?.category
            ? resolveCategoryDisplayName(
                quickSale.type === "in" ? "business_sale" : "business_expense",
                quickSale.category,
              )
            : "-",
        },
        {
          title: I18n.notes,
          value: quickSale?.note || "-",
        },
      ];

  return (
    <UBRightSidebar
      id={"quick_sale"}
      title="transaction_detail"
      open={open}
      onClose={() => onClose(false)}
      footerLeft={
        quickSale.status?.toLowerCase() === "paid" && isShowDeleteBtn ? (
          <ParagraphText className={styles.paidInfo} id="quick_sale_paid_info">
            <span>
              <InfoIconNew />
            </span>
            {I18n.paid_transactions_cannot_be_edited}
          </ParagraphText>
        ) : null
      }
      footerRight={
        quickSale.status?.toLowerCase() === "paid" ? (
          isShowDeleteBtn ? (
            <UBButton
              id="quick_sale_delete_icon"
              className="UBRightSidebarFooterIcon ubDeleteButton"
              title={I18n.delete}
              onClick={() => {
                triggerLogEvent(analytics, "sidebar_delete", {
                  id: quickSale?.id,
                  status: quickSale?.status,
                });
                handleDelete(orders);
              }}
            />
          ) : null
        ) : (
          <>
            {isShowDeleteBtn ? (
              <UBButton
                id="quick_sale_delete_icon"
                className="UBRightSidebarFooterIcon ubDeleteButton"
                title={I18n.delete}
                onClick={() => {
                  triggerLogEvent(analytics, "sidebar_delete", {
                    id: quickSale?.id,
                    status: quickSale?.status,
                  });
                  handleDelete(orders);
                }}
              />
            ) : null}
            {isShowEditBtn ? (
              <UBButton
                id="quick_sale_edit"
                className="UBRightSidebarFooterIcon ubSecondaryButton"
                title={I18n.edit}
                onClick={(e) =>
                  handleEdit ? handleEdit(e) : handleEditIcon(e)
                }
              />
            ) : null}
          </>
        )
      }
    >
      <Box className={styles.content}>
        <QuickSalePaymentDetails
          displayData={quickSale}
          handleDownload={isShowInvoiceDownload ? handleDownload : undefined}
          onRecordPayment={handleMarkAsPaid}
          isNotShowReceipt={isNotShowReceipt}
          firstButtonTitle={firstButtonTitle}
          otherCstmBtn={otherCstmBtn}
          invoiceBtnTitle={invoiceBtnTitle}
          downloadLoading={downloadLoading}
          isCustomerTransaction={isCustomerTransaction}
          unpaidAmountVariant={unpaidAmountVariant}
          hideReceiptActions={hideReceiptActions}
        />

        <Box className={styles.divider} />

        <AppCustomerSiderbarDetail custInfoData={CustInfoData} />

        {isShowAttachment ? (
          <Box className={styles.transactionDetailBox}>
            <Box className={styles.transactionDetailBoxInner}>
              <ParagraphText>{I18n.attachment || "Attachment"}</ParagraphText>
              <Box className={styles.attachmentBoxListing}>
                {imageUrl && Array.isArray(imageUrl) ? (
                  imageUrl.map((url, index) => (
                    <ParagraphText
                      key={index}
                      className={`${styles.attachmentValue} ${url?.file ? styles.attachmentLink : ""}`}
                      onClick={
                        url?.file
                          ? () => openFileInNewTab(url?.file)
                          : undefined
                      }
                      sx={{ cursor: url?.file ? "pointer" : "default" }}
                    >
                      <span>{getAttachmentName(url)}</span>
                      <BackIconNew />
                    </ParagraphText>
                  ))
                ) : imageUrl?.file ? (
                  <ParagraphText
                    className={`${styles.attachmentValue} ${styles.attachmentLink}`}
                    onClick={() => {
                      triggerLogEvent(analytics, "sidebar_attachment_open", {
                        id: quickSale?.id,
                        file_name: getAttachmentName(imageUrl),
                      });
                      openFileInNewTab(imageUrl?.file);
                    }}
                    sx={{ cursor: "pointer" }}
                  >
                    {getAttachmentName(imageUrl)}
                  </ParagraphText>
                ) : imageUrl ? (
                  <ParagraphText
                    className={`${styles.attachmentValue} ${styles.attachmentLink}`}
                    onClick={() => {
                      triggerLogEvent(analytics, "sidebar_attachment_open", {
                        id: quickSale?.id,
                        file_name: getAttachmentName(imageUrl),
                      });
                      openFileInNewTab(imageUrl);
                    }}
                    sx={{ cursor: "pointer" }}
                  >
                    {getAttachmentName(imageUrl)}
                  </ParagraphText>
                ) : (
                  "-"
                )}
              </Box>
            </Box>
          </Box>
        ) : null}

        {orders.length > 0 ? (
          <Fragment>
            <Box className={styles.divider} />
            <Box className={styles.itemBox}>
              <ParagraphText className={styles.itemBoxTitle}>
                {I18n.items}
              </ParagraphText>
              <Box className={styles.itemTableHeader}>
                <Box className={styles.itemTableHeaderCell}>
                  <ParagraphText className="fontSize14 fontWeight400 blue800Color">
                    {I18n.name}
                  </ParagraphText>
                </Box>
                <Box className={styles.itemTableHeaderCell}>
                  <ParagraphText className="fontSize14 fontWeight400 blue800Color">
                    {I18n.quantity}
                  </ParagraphText>
                </Box>
                <Box className={styles.itemTableHeaderCell}>
                  <ParagraphText className="fontSize14 fontWeight400 blue800Color">
                    {I18n.price}
                  </ParagraphText>
                </Box>
              </Box>
              <Box className={styles.itemTableBody}>
                {orders.map((item, key) => (
                  <Box className={styles.itemTableHeader} key={key}>
                    <Box className={styles.itemTableHeaderCell}>
                      <ParagraphText className="fontSize12 fontWeight400 newFontColor">
                        {item.name}
                      </ParagraphText>
                    </Box>
                    <Box className={styles.itemTableHeaderCell}>
                      <ParagraphText className="fontSize12 fontWeight400 newFontColor">
                        x{item.quantity}
                      </ParagraphText>
                    </Box>
                    <Box className={styles.itemTableHeaderCell}>
                      <ParagraphText className="fontSize12 fontWeight400 newFontColor">
                        {`Rs. ${formatNum(quickSale?.type == "in" ? item?.selling_price : quickSale?.type == "out" ? item?.cost_price : quickSale?.payment_mode?.toLowerCase() == "jama" || quickSale?.tranType?.toLowerCase() == "bill" ? item.cost_price : item.selling_price || 0)}`}
                      </ParagraphText>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Fragment>
        ) : null}
        <UBAppModal
          id="sidebar_record_payment_modal"
          className={"previewImageModal"}
          backdropClassName="previewModalBackdrop"
          open={previewImageOpen}
          header={{
            handleClose: () => setPreviewImageOpen(false),
            title: I18n.preview_image,
          }}
        >
          <img src={imageUrl?.file} alt="" />
        </UBAppModal>
      </Box>
    </UBRightSidebar>
  );
};

const enhance = withObservables(
  ["quickSale", "business", "isCustomerTransaction"],
  ({ quickSale, isCustomerTransaction }) => ({
    orders: quickSale?.items?.length
      ? of([...quickSale.items])
      : quickSale?.orders && !isCustomerTransaction
        ? quickSale.orders.observe()
        : isCustomerTransaction
          ? quickSale?.txns?.id
            ? quickSale.txns.observe().pipe(
                switchMap((txns) => txns.orders.observe()),
                catchError(() => of([])),
              )
            : quickSale?.invoice?.id
              ? quickSale.invoice.observe().pipe(
                  switchMap((invoice) => invoice.orders.observe()),
                  catchError(() => of([])),
                )
              : quickSale.orders
                ? quickSale.orders.observe()
                : of([])
          : of([]),
    customerDetail: quickSale?.customer
      ? quickSale?.customer.observe().pipe(catchError((error) => of(null)))
      : of({}),
    paymentImage: quickSale?.payment
      ? quickSale?.payment?.observe()?.pipe(
          map((payments) => {
            const arr = Array.isArray(payments) ? payments : [];
            const withImage = arr.find((p) => p?.image_url);
            return withImage?.image_url || null;
          }),
          catchError(() => of(null)),
        )
      : of(null),
  }),
);

export default enhance(SidebarBodyContent);
